import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useAgeCalculation = () => {
    const { t } = useTranslation('common');

    return useMemo(() => {
        const emptyValue = t('common:empty.na');
        return {
            formatAge: (birthDate: string | Date | Dayjs | null | undefined): string => {
                if (birthDate === null || birthDate === undefined || birthDate === '') {
                    return emptyValue;
                }

                const birth = dayjs(birthDate);
                if (!birth.isValid()) {
                    return emptyValue;
                }

                const today = dayjs();
                let age = today.year() - birth.year();

                // Check if birthday hasn't occurred yet this year
                if (today.month() < birth.month() || (today.month() === birth.month() && today.date() < birth.date())) {
                    age--;
                }

                // Guard against future birth dates that would result in negative ages
                if (age < 0) {
                    return '0';
                }

                return age.toString();
            },
        };
    }, [t]);
};

export default useAgeCalculation;
